import { useParams } from "react-router-dom";

import { Divider2 } from "@/ui2/atoms/Divider";
import { useCurrentAcuityScore } from "@/features/acuity/api/queries/useCurrentAcuityScore";
import type { UUID } from "@/core/types";

import { AcuityHeaderDetails } from "./components/AcuityHeaderDetails";
import { AcuityHeaderSkeleton } from "./components/AcuityHeaderSkeleton";
import { ReportAcuityMenu } from "./components/ReportMenu";

export function PatientAcuity() {
  const { patientId } = useParams<{ patientId: UUID }>();

  const {
    data: currentAcuityScore,
    isLoading,
    isSuccess,
  } = useCurrentAcuityScore({
    patientId,
  });

  return (
    <>
      <div className="tw:flex tw:items-center tw:justify-between tw:gap-1">
        {isLoading && <AcuityHeaderSkeleton />}

        {isSuccess && (
          <>
            <AcuityHeaderDetails currentAcuityScore={currentAcuityScore} />
            <ReportAcuityMenu currentAcuityScore={currentAcuityScore} />
          </>
        )}
      </div>

      <Divider2 className="tw:lg:-ml-4" />
    </>
  );
}
